export const CARD_FONT = "Lato, sans-serif";

export const RISK_COLORS = {
  CRITICAL: { bg: "var(--Danger-50, #DE350B)", color: "#FFFFFF", border: "#DE350B" },
  HIGH:     { bg: "var(--Danger-30, #FFD2C7)", color: "#DE350B", border: "#DE350B" },
  MEDIUM:   { bg: "var(--Warning-30, #FFE999)", color: "#8A5C00", border: "#E4A11A" },
  LOW:      { bg: "var(--Success-30, #ABF5D1)", color: "#00754E", border: "#00754E" },
};

export const RISK_TIER_RANK = { CRITICAL: 4, HIGH: 3, MEDIUM: 2, LOW: 1 };

export const PORTFOLIO_RISK_SORT_OPTIONS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];

export function portfolioRiskSortLabel(sortKey = "critical") {
  if (sortKey === "low") return "Sort. Risk low to high";
  return "Sort. Risk high to low";
}

export function sortAppsByRiskTier(apps, sortKey = "critical") {
  const focusRank = RISK_TIER_RANK[String(sortKey || "critical").toUpperCase()] || 0;
  const ascending = sortKey === "low";

  return [...apps].sort((a, b) => {
    const av = RISK_TIER_RANK[String(a.risk_level || "").toUpperCase()] || 0;
    const bv = RISK_TIER_RANK[String(b.risk_level || "").toUpperCase()] || 0;

    if (ascending) {
      if (av !== bv) return av - bv;
    } else {
      const aFocus = av === focusRank ? 1 : 0;
      const bFocus = bv === focusRank ? 1 : 0;
      if (aFocus !== bFocus) return bFocus - aFocus;
      if (av !== bv) return bv - av;
    }

    return String(a.project_name || "").localeCompare(String(b.project_name || ""), undefined, {
      sensitivity: "base",
    });
  });
}

export const MODEL_PILL_SX = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: 24,
  px: "8px",
  borderRadius: "12px",
  border: "1px solid #BDD6FF",
  bgcolor: "#F0F6FF",
  fontFamily: CARD_FONT,
  fontWeight: 700,
  fontSize: 13,
  lineHeight: "24px",
  letterSpacing: 0,
  color: "var(--Primary-50, #005BF0)",
  maxWidth: 180,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export function resolveAppStatusDisplay(app) {
  const status = String(app.app_status || "Draft");
  if (status === "Passed" || (app.test_total > 0 && app.test_progress >= app.test_total)) {
    return { label: "All tests passed", color: "#00754E", kind: "success" };
  }
  if (status === "Test Running") {
    return { label: "Test Running", color: "#005BF0", kind: "running" };
  }
  if (status === "Flagged" || app.critical_count > 0) {
    return { label: "Needs attention", color: "#DE350B", kind: "danger" };
  }
  return { label: status, color: "#707070", kind: "neutral" };
}

export function resolveProgressBarColor(app, status) {
  const allComplete =
    status.kind === "success"
    || (app.test_total > 0 && app.test_progress >= app.test_total);
  if (allComplete) {
    return "var(--Success-60, #00754E)";
  }
  return "var(--Primary-50, #005BF0)";
}

export const PORTFOLIO_TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      bgcolor: "#000000",
      borderRadius: "4px",
      px: "12px",
      py: "8px",
      fontFamily: CARD_FONT,
      fontWeight: 400,
      fontSize: 12,
      lineHeight: "18px",
      letterSpacing: 0,
      color: "#FFFFFF",
      "& .MuiTooltip-arrow": { color: "#000000" },
    },
  },
};
